import { useCallback } from 'react';
import { useUrlFilters } from '@/lib/hooks/useUrlFilters';
import type { PackageFilters } from '../types';

const defaults: PackageFilters = {
  s: undefined,
  limit: 10,
  page: 0,
  orderBy: 'createdAt',
  order: 'desc',
  'createdAt.min': undefined,
  'createdAt.max': undefined,
};

const numberFields: (keyof PackageFilters)[] = ['limit', 'page'];

export function useSuccessPackageFilters() {
  const { updateFilter, ...rest } = useUrlFilters<PackageFilters>({ defaults, numberFields });

  const setSearch = useCallback(
    (search: string) => updateFilter('s', search || undefined, true),
    [updateFilter]
  );

  return { ...rest, updateFilter, setSearch };
}
